import FloatingLabelInput from "./floatingLabelInput";
import FloatingLabelTextArea from "./floatingLabelTextArea";


const BusinessEditModal = ({ isOpen, handleChange, handleBlur, onClose, business, onSave, errors }) => {
    if (!isOpen) return null;
  
    return (
      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-40">
        <div className="relative top-20 mx-auto p-5 border  shadow-lg rounded-md bg-white w-1/2">
          <h3 className="text-lg font-bold text-center mb-4">Edit Business Details</h3>
            <form onSubmit={onSave}>
                <div className="pb-12 space-y-12">
                    <div className="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                        <div className="sm:col-span-3">
                            <FloatingLabelInput 
                                    handleChange={handleChange} 
                                    handleBlur={handleBlur}
                                    value={business.name}
                                    name="name" 
                                    id="name" 
                                    label="Business Name" 
                                    required={true}
                                />
                        </div>
                        <div className="sm:col-span-3">
                            <FloatingLabelInput 
                                    handleChange={handleChange} 
                                    handleBlur={handleBlur}
                                    value={business.industry} 
                                    name="industry" 
                                    id="industry" 
                                    label="Industry" 
                                    required={true}
                                />
                        </div>
                        
                    </div>
                    <div className="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                        <div className="sm:col-span-3">
                                <FloatingLabelInput 
                                        handleChange={handleChange} 
                                        handleBlur={handleBlur}
                                        value={business.contactName} 
                                        name="contactName" 
                                        id="contactName" 
                                        label="Contact Name" 
                                        required={true}
                                    />
                        </div>
                        <div className="sm:col-span-3">
                            <FloatingLabelInput 
                                    handleChange={handleChange} 
                                    handleBlur={handleBlur}
                                    value={business.contactEmail} 
                                    error={errors.contactEmail} 
                                    name="contactEmail" 
                                    id="contactEmail" 
                                    type="email" 
                                    label="Contact Email" 
                                    required={true}
                                />
                        </div>
                    </div>
                    <div className="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                        
                        <div className="sm:col-span-3">
                            <FloatingLabelInput 
                                    handleChange={handleChange} 
                                    handleBlur={handleBlur}
                                    value={business.contactNumber} 
                                    error={errors.contactNumber}
                                    name="contactNumber" 
                                    id="contact_number" 
                                    type="tel" 
                                    label="Contact Number" 
                                    required={true}
                                />
                        </div>
                        <div className="sm:col-span-3">
                            <FloatingLabelInput 
                                    handleChange={handleChange} 
                                    handleBlur={handleBlur}
                                    value={business.rentAmount} 
                                    name="rentAmount" 
                                    id="rentAmount" 
                                    type="text" 
                                    label="Rent Amount" 
                                    required={true}
                                    isCurrency={true}
                                />
                        </div>
                    </div>
                    <div className="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                        <div className="sm:col-span-6">
                            <FloatingLabelTextArea 
                                    handleChange={handleChange} 
                                    value={business.comments} 
                                    // error={managerDetailsState.formErrors.rentAmount}
                                    name="comments" 
                                    id="comments" 
                                    label="Comments" 
                                    rows="3"
                                    // required={true}
                                />
                        </div>
                    </div>
                    <div className='flex items-center justify-center gap-4'>
                            <button 
                                className="text-custom-purple border-2 border-custom-purple font-semibold px-4 py-2 rounded-full flex items-center justify-center min-w-40 min-h-12"
                                type='submit'
                                onClick={onClose}
                                >
                                Cancel
                            </button>
                            <button 
                                className="bg-custom-purple text-white font-semibold px-4 py-2 rounded-full flex items-center justify-center min-w-40 min-h-12"
                                type='submit'
                                >
                                Save
                            </button>
                        </div>
                </div>
            </form>
        </div>
      </div>
    );
  };

export default BusinessEditModal;